import {
  ATTACHMENT_ERROR_I18N_KEYS
} from './attachmentValidation';

const GENERIC_CODE_TO_KEY = {
  'permission-denied': 'records.errors.permission_denied',
  'access-denied': 'records.errors.permission_denied',
  'not-found': 'records.errors.not_found',
  'unauthenticated': 'records.errors.unauthenticated',
  'network-error': 'records.errors.network_error'
};

const GENERIC_TYPE_TO_KEY = {
  PERMISSION_DENIED: 'records.errors.permission_denied',
  ACCESS_DENIED: 'records.errors.permission_denied',
  NOT_FOUND: 'records.errors.not_found',
  UNAUTHENTICATED: 'records.errors.unauthenticated',
  NETWORK_ERROR: 'records.errors.network_error'
};

const CODE_TO_KEY = {
  ...GENERIC_CODE_TO_KEY,
  ...ATTACHMENT_ERROR_I18N_KEYS
};

const getErrorCode = (error) => error?.code || error?.cause?.code || null;

const getErrorType = (error) => error?.type || error?.cause?.type || null;

const normalizeCode = (value) => {
  if (typeof value !== 'string') return null;
  const normalized = value.trim().toLowerCase().replace(/_/g, '-');
  return normalized || null;
};

const normalizeType = (value) => {
  if (typeof value !== 'string') return null;
  const normalized = value.trim().replace(/[-/]/g, '_').toUpperCase();
  return normalized || null;
};

const mapCodeToKey = (value) => {
  const normalizedCode = normalizeCode(value);
  if (!normalizedCode) return null;

  if (CODE_TO_KEY[normalizedCode]) {
    return CODE_TO_KEY[normalizedCode];
  }

  const scopedDelimiterIndex = normalizedCode.lastIndexOf('/');
  if (scopedDelimiterIndex === -1) {
    return null;
  }

  const scopedCode = normalizedCode.slice(scopedDelimiterIndex + 1);
  return CODE_TO_KEY[scopedCode] || null;
};

const mapTypeToKey = (value) => {
  const normalizedType = normalizeType(value);
  if (!normalizedType) return null;
  return GENERIC_TYPE_TO_KEY[normalizedType] || null;
};

export function mapRecordsErrorToKey(error, { fallbackKey = 'records.errors.generic' } = {}) {
  const explicitKey = typeof error?.i18nKey === 'string' ? error.i18nKey : null;
  if (explicitKey) {
    return explicitKey;
  }

  const keyFromCode = mapCodeToKey(getErrorCode(error));
  if (keyFromCode) {
    return keyFromCode;
  }

  const keyFromType = mapTypeToKey(getErrorType(error));
  if (keyFromType) {
    return keyFromType;
  }

  return fallbackKey;
}

export default mapRecordsErrorToKey;
